import { Component, ChangeDetectorRef } from '@angular/core';
import { AbstractWidgetComponent } from '../abstract.widget';
import { WidgetsHelper } from '../widgets.helper';
import { WidgetConfiguration } from '../../../models/widget-configuration.model';

// @dynamic
@Component({
  selector: 'interface-widget-plain-html',
  template: `<ng-container *ngIf="!preview; else previewTemplate">
  <div *ngIf="plainHtml" [innerHTML]="plainHtml | safe:'html'"></div>
</ng-container>

<ng-template #previewTemplate>
  <div draggable="true" (dragstart)="dragStartHandler($event, { cols: 5, rows: 3 })">
    <interface-widget-preview [data]="sanitizeData(true)"></interface-widget-preview>
  </div>
</ng-template>
`,
  styles: [``],
})
export class PlainHtmlComponent extends AbstractWidgetComponent {

  constructor(protected ref: ChangeDetectorRef) {
    super(ref);
  }

  static get CONFIGURATION(): WidgetConfiguration[] {
    return [
      ...WidgetsHelper.defaultConfigurations,
      { key: 'plainHtml', name: 'Plain Html', type: 'textarea', placeholder: 'Write your HTML code here.' },
    ];
  }

  static get OPTIONS() {
    return Object.assign(
      WidgetsHelper.defaultOptions,
      {
        cols: {
          max: 5,
          min: 5,
        },
        rows: {
          max: 10,
          min: 3,
        },
      },
    );
  }

  static get DESCRIPTION() {
    return 'Widget for HTML code.';
  }

  static get TITLE() {
    return 'HTML Widget';
  }

  static get PLAINHTML() {
    return `<head>
<style>
  div.plain-html-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  p.plain-html-p {
    font-size: 18px;
  }
</style>
</head>
<body>
<div class="plain-html-body">
<h1>Welcome to DotGov Engineer</h1>
<p class="plain-html-p">On this widget configuration you can write your own html code.</p>
</div>
</body>`;
  }

  static get ICON() {
    return 'fa fa-code fa-4x';
  }
}
